import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [restaurant, setRestaurant] = useState(null);

  useEffect(() => {
    const fetchRestaurant = async () => {
      try {
        const response = await axios.get('/api/restaurant');
        setRestaurant(response.data);
      } catch (error) {
        console.error('Failed to load restaurant data for footer:', error);
      }
    };

    fetchRestaurant();
  }, []);

  return (
    <footer className="bg-gray-900 text-gray-300 mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white font-bold text-lg mb-4">
              {restaurant?.name || 'Restaurant'}
            </h3>
            <p className="text-sm leading-relaxed mb-4">
              {restaurant?.description || ''}
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-amber-500 transition-colors">Menu</Link>
              </li>
              {restaurant?.rewardsEnabled && (
                <li>
                  <Link
                    to="/rewards"
                    className="hover:text-amber-500 transition-colors"
                  >
                    Rewards
                  </Link>
                </li>
              )}
              <li>
                <Link to="/reviews" className="hover:text-amber-500 transition-colors">Reviews</Link>
              </li>
              <li>
                <Link to="/about-us" className="hover:text-amber-500 transition-colors">About Us</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy-policy" className="hover:text-amber-500 transition-colors">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" className="hover:text-amber-500 transition-colors">Terms & Conditions</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-start text-white text-sm space-y-2">
  
          {/* LINE 1 */}
          <div className="flex items-center gap-3 opacity-80">
            <span className="leading-none">Served with</span>
            <a
              href="https://orderkit.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
            <img
              src="/Orderkit_WHT.svg"
              alt="OrderKit"
              className="h-5 w-auto translate-y-[-2px]"
            />
          </a>
          </div>

          {/* LINE 2 */}
          <p className="text-xs opacity-70">
            © {currentYear} {restaurant?.name || 'Restaurant'}. All rights reserved.
          </p>

        </div>
      </div>
    </footer>
  );
}